import React from 'react'
import { Button } from '@mui/material'
import { useWatch } from 'react-hook-form'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { InstallationFormModel } from 'src/Libs/flow/installation/forms'
import { useInstallationForm } from 'src/Libs/flow/installation/hooks'
import { getPowerConsumptionLimit } from 'src/Libs/flow/installation/utils'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'
export const AutoCalculateButton: React.FC = () => {
  const { t } = useCustomTranslation()
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()

  const { control, setValue } = useInstallationForm()

  const installation = useWatch({ control })

  const calculatedConsumptionLimit = getPowerConsumptionLimit(
    installation as InstallationFormModel,
    installation.ioInterfaces?.htc320h?.nominalPower || 0
  )
  const currentConsumptionLimit = installation.ioInterfaces?.htc320h?.totalPowerConsumption || 0

  const handleClick = (): void => {
    if (!installation.ioInterfaces?.htc320h) return
    setValue('ioInterfaces.htc320h.totalPowerConsumption', calculatedConsumptionLimit, {
      shouldDirty: true,
    })
  }

  return (
    <Button
      variant="outlined"
      color="secondary"
      sx={{ py: 0 }}
      disabled={!canEdit || calculatedConsumptionLimit === currentConsumptionLimit}
      onClick={handleClick}
    >
      {t('installation.submeterEditor.input.auto-calculate')}
    </Button>
  )
}
